export default __webpack_public_path__ + "static/media/gb-ork.6f060d1f.svg";